export default "__VITE_ASSET__CXSqwGJD__"